module.exports = __webpack_public_path__ + "img/198.da0cff06.jpg";